import Dialog, { DialogTitle, DialogContent } from "components/common/Dialog";
import "./TermsConditionsModal.scss";

interface TermsConditionsModalProps {
  open: boolean;
  onClose: () => void;
}

function TermsConditionsModal({ open, onClose }: TermsConditionsModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      size="sm"
      width="498px"
      title={<DialogTitle title="Terms & Conditions" showCloseIcon onClose={onClose} />}
      content={
        <DialogContent>
          <div className="terms-modal-content">
            <ol className="terms-list">
              <li>Referrals must be new businesses that have not previously engaged with Edge.</li>
              <li>
                The $2,000 credit is awarded once the referred business completes its first successful hire and remains
                active with Edge for at least 90 days.
              </li>
              <li>Your peer will get a $2,000 discount from Edge</li>
              <li>Credits are non-transferable and can only be used toward Edge services.</li>
              <li>There is no limit to the number of referrals you can make.</li>
              <li>Edge reserves the right to modify or terminate the referral program at any time.</li>
              <li>Any fraudulent or abusive activity may result in disqualification from the program.</li>
            </ol>
          </div>
        </DialogContent>
      }
    />
  );
}

export default TermsConditionsModal;
